import Booklets from '@/components/views/booklets/Booklets.vue';
import BookletView from '@/components/views/booklets/BookletView.vue';

const bookletsChildren = [
    {
        path: ':filter',
        name: 'booklets.filter',
        component: Booklets,
        props: true,
        meta: {
            pageTitleConfig: {
                showPageTitle: true,
                showBackButton: false,
                pageTitle: 'BOOKLETS.PAGE_TITLE',
                pageTitleParams: null,
                backButtonLink: '',
                showFooterNav: false
            }
        }
    },
    {
        path: ':filter/view/:id',
        name: 'booklets.filter.view',
        component: BookletView,
        props: true,
        meta: {
            pageTitleConfig: {
                showPageTitle: true,
                showBackButton: true,
                pageTitle: 'BOOKLETS.PAGE_TITLE',
                pageTitleParams: null,
                backButtonLink: {name: 'booklets.filter'},
                showFooterNav: false
            }
        },
    }
];

export default bookletsChildren;